import {useTranslation} from "react-i18next";
import './Credits.css';

const Credits = () => {
    const {t} = useTranslation();

    return (
        <div className="credits">
            <div className="by">{t('Created by')}</div>
            <div className="name"><a href="https://www.linkedin.com/in/christofferk/" target="_blank" rel="noreferrer">Christoffer Kaalund</a></div>
        </div>
    )
}

export default Credits;